import React from 'react';
import { Box, Container, useMediaQuery, CssBaseline, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../styles/theme';
import GoogleSignInButton from '../components/GoogleSignInButton';
import { GoogleAuthService } from '../services/GoogleAuthService';
import { router } from '@inertiajs/react';
import logo from '../assets/rounded_logo.svg';

const RoommateLoginPage: React.FC = () => {
    const isMobile = useMediaQuery('(max-width:600px)');

    const handleGoogleSignIn = async (response: any) => {
        try {
            // Landlord/customer auth only — roommates mark paid via magic links, not this page.
            await GoogleAuthService.handleGoogleResponse(response, () => {
                router.visit('/util/dashboard');
            });
        } catch {
            console.error('Sign-in failed');
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box
                sx={{
                    backgroundColor: '#FFFA66',
                    minHeight: '100vh',
                    width: '100vw',
                    margin: 0,
                    padding: isMobile ? 4 : 3,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: isMobile ? 'flex-start' : 'center',
                    boxSizing: 'border-box',
                    overflowX: 'hidden',
                    position: 'relative'
                }}
            >
                {/* Logo in Top Left */}
                <Box
                    component="img"
                    src={logo}
                    alt="Heyy Property Logo"
                    sx={{
                        position: 'absolute',
                        top: isMobile ? 16 : 24,
                        left: isMobile ? 16 : 24,
                        width: isMobile ? '80px' : '120px',
                        height: 'auto',
                        zIndex: 1
                    }}
                />
                <Container
                    maxWidth={false}
                    disableGutters={true}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: isMobile ? 'flex-start' : 'center',
                        justifyContent: 'center',
                        textAlign: isMobile ? 'left' : 'center',
                        width: '100%',
                        maxWidth: isMobile ? '100%' : '600px',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 700,
                                color: 'black',
                                textAlign: 'center',
                                mb: 1,
                                fontSize: { xs: '1.75rem', sm: '2.25rem' },
                            }}
                        >
                            Utility Dashboard
                        </Typography>
                        <Typography
                            variant="h6"
                            sx={{
                                color: 'black',
                                textAlign: 'center',
                                fontWeight: 450,
                                fontSize: { xs: '1.1rem', sm: '1.25rem' },
                                lineHeight: 1.4,
                                mb: 4,
                            }}
                        >
                            Sign in to manage your household utilities.
                        </Typography>

                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                '& > *': {
                                    width: isMobile ? '60%' : '320px',
                                    maxWidth: isMobile ? '60%' : '320px',
                                }
                            }}
                        >
                            <GoogleSignInButton googleCallback={handleGoogleSignIn} />
                        </Box>
                    </Box>
                </Container>
            </Box>
        </ThemeProvider>
    );
};

export default RoommateLoginPage;
